module.exports = __webpack_public_path__ + "files/1639e32a34766fc43b5be88e40e929a6.png";